export default __webpack_public_path__ + "static/media/editicon.b6cfc648.svg";